import { FC, memo } from 'react'

import { Text } from '@cash-me/react-components'

import { Breadcrumb } from 'components/breadcrumb'
import { Grid, Col } from 'components/grid'
import useWindowSize from 'src/presentation/hooks/useWindowSize'

import * as S from './styles'

const Hero: FC = memo(() => {
  const BreadcrumbLinks = [{ label: 'Golpes e Fraudes' }]
  const { isDesktop } = useWindowSize()

  return (
    <S.Hero>
      <Grid col={{ phone: 1, tablet: 1, desktop: 12 }} gap={{ phone: 'md', tablet: 'md', desktop: 'md' }}>
        <Col col={{ desktop: 7 }} start={{ desktop: 2 }}>
          {isDesktop ? 
            <Breadcrumb
              linkColor='primary-text-strong'
              textColor='primary-text-strong'
              items={BreadcrumbLinks} 
            /> : 
            ' '
          }
          <Text as="h1" size="heading2" color="var(--colors-primary-text-strong)" weight="medium">
            Impulsione sua segurança digital!{' '}
            <Text as="span" size="heading2" color="var(--colors-pink-text-contrast)" weight="medium">
              A CashMe é sua aliada
            </Text>
          </Text>
        </Col>
        <Col col={{ desktop: 6 }} start={{ desktop: 2 }}>
          <Text color="var(--colors-primary-text-strong)" size="body1">
            Veja como denunciar golpes e fraudes e aprenda a reconhecer os tipos mais comuns.
          </Text>
        </Col>
      </Grid>
    </S.Hero>
  )
})

Hero.displayName = 'Hero'

export default Hero
